/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DnepduosEntity } from './dnepduosEntity.model';


export interface ListResponseDnepduosEntity { 
    itemCount?: number;
    items?: Array<DnepduosEntity>;
    params?: { [key: string]: any; };
}

